import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';
import { useViewer } from '@/features/session';
import { KEEP_PLAN } from '@/graphql/mutations/billing';

type UseKeepPlanResult = { keepPlan: () => Promise<void>; isKeeping: boolean };

/** Removes a scheduled cancellation. */
export function useKeepPlan(): UseKeepPlanResult {
  const { refreshViewer } = useViewer();
  const [mutate, { loading }] = useMutation(KEEP_PLAN);

  const keepPlan = useCallback(async () => {
    await mutate();
    await refreshViewer();
  }, [mutate, refreshViewer]);

  return { keepPlan, isKeeping: loading };
}
